// client/components/system/ReleaseModal.jsx
import { useEffect, useState, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, ArrowRight, Check } from "lucide-react";
import { ReleasesAPI } from "../../constants/systemCommsApi.js";
import { useTheme } from "../../context/ThemeContext.jsx";
import ModalOrSheet from "../ui/ModalOrSheet.jsx";
import AppButton from "../ui/AppButton.jsx";
import { cn } from "../../utils/themeClasses.js";
export default function ReleaseModal() {
    const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const fetched = useRef(false);
  const mountedRef = useRef(true);
  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);
  useEffect(() => {
    if (fetched.current) return;
    fetched.current = true;
    ReleasesAPI.latest().then(d => {
      if (!mountedRef.current) return;
      if (d?.shouldShowModal && d?.latestRelease) {
        setData(d);
        setOpen(true);
      }
    }).catch(() => {});
  }, []);
  const handleDismiss = useCallback(() => {
    setOpen(false);
    if (data?.latestRelease?.version) {
      ReleasesAPI.markSeen(data.latestRelease.version).catch(() => {});
    }
  }, [data]);
  const handleDetails = useCallback(() => {
    setOpen(false);
    if (data?.latestRelease?.version) {
      ReleasesAPI.markSeen(data.latestRelease.version).catch(() => {});
      navigate(`/releases/${data.latestRelease.version}`);
    }
  }, [data, navigate]);
  if (!open || !data?.latestRelease) return null;
  const {
    version,
    title,
    summary
  } = data.latestRelease;
  const bullets = summary?.bullets || [];
  return <ModalOrSheet open={open} onClose={handleDismiss} maxWidth="md">
      <div className="p-1">
          <div className="flex items-center gap-2 mb-4">
            <div className={`p-2 rounded-xl ${"bg-blue-500/20"}`}>
              <Sparkles className={`w-5 h-5 ${"text-blue-400"}`} />
            </div>
            <div>
              <p className={`text-xs font-medium ${"text-blue-400"}`}>
                Neues Update
              </p>
              <p className={`text-sm font-mono ${"text-white/40"}`}>
                v{version}
              </p>
            </div>
          </div>

          <h2 className={`text-lg font-bold mb-3 ${"text-white"}`}>
            {title}
          </h2>

          {bullets.length > 0 && <ul className="space-y-2 mb-5">
              {bullets.slice(0, 5).map((b, i) => <li key={i} className="flex items-start gap-2">
                  <Check className={`w-4 h-4 mt-0.5 flex-shrink-0 ${"text-green-400"}`} />
                  <span className={`text-sm ${"text-white/70"}`}>{b}</span>
                </li>)}
            </ul>}

          <div className="flex gap-2">
            <AppButton type="button" variant="secondary" onClick={handleDismiss} className={cn("flex-1 px-4 py-2.5 rounded-xl text-sm font-normal min-h-[44px]", "text-white/70")}>
              Verstanden
            </AppButton>
            <AppButton type="button" variant="primary" onClick={handleDetails} className="flex-1 px-4 py-2.5 rounded-xl text-sm font-normal min-h-[44px] flex items-center justify-center gap-1.5">
              Details <ArrowRight className="w-3.5 h-3.5" />
            </AppButton>
          </div>
      </div>
    </ModalOrSheet>;
}